import {
  getCommonOptionsBar,
  initChart,
  printDataChart,
  printNoDataChart,
} from '../common';

export function echartUsuarisTotalsBarMonth(vis, datos) {
  if (datos.resultset.length === 0) {
    printNoDataChart(
      '#chartUsuarisTotalsBarMonth',
      '#no_dataUsuarisTotalsBarMonth',
    );
  } else {
    printDataChart(
      '#no_dataUsuarisTotalsBarMonth',
      '#chartUsuarisTotalsBarMonth',
    );
    const option = getCommonOptionsBar(
      datos.resultset,
      'Viatges',
      undefined,
      "ÚS D'EMT. USUARIS TOTALS: EVOLUCIÓ MENSUAL",
      'Nombre viatges EMT',
    );
    initChart('chartUsuarisTotalsBarMonth', option);
  }
}
